import script from "./TopPlatformPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopPlatformPanel.vue?vue&type=script&setup=true&lang=ts"

import "./TopPlatformPanel.vue?vue&type=style&index=0&id=270d883a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-270d883a"]])

export default __exports__